import React, { useEffect, useState, useMemo } from 'react'

import {
  CompanyCountriesDto,
  CompanyId,
  DeleteUser$Request,
  DivisionDto,
  DivisionId,
  GetCompanySignUpCode$Request,
  GetSpecificCompanyUsers$Request,
  SetUserCountry$Request,
  SetUserDivision$Request,
  ToggleUserStatus$Request,
  UserCompanyDto,
  UserDto,
  UserId,
} from '../../../../services/api.types'
import NotificationsWrapper from '../../../../components/Notification/NotificationsWrapper'
import { Card } from '../../../../components/Card/Card'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from '@material-ui/core'
import { t } from 'ttag'
import YumSmallSelect from '../../../../components/YumSmallSelect/YumSmallSelect'
import FileDownloadIcon from '@mui/icons-material/FileDownload'

import MaterialReactTable, {
  MRT_Column,
  type MRT_ColumnDef,
  MRT_FullScreenToggleButton,
  MRT_RowSelectionState,
  MRT_ToggleFiltersButton,
  MRT_ToggleGlobalFilterButton,
} from 'material-react-table'
import { getFullName } from '../../../../common/helpers/translations'
import { getShortDateWithTimeString } from '../../../../common/helpers/date'
import YumSwitch from '../../../../components/YumSwitch/YumSwitch'
import YumButton from '../../../../components/YumButton/YumButton'
import { gray, red } from '../../../../styles/material-ui-theme-v2'
import { getContractPeriod } from '../../../../common/helpers/challenges'
import Hidden from '@material-ui/core/Hidden'
import { ReactTextareaAutocomplete } from 'stream-chat-react/dist/components/AutoCompleteTextarea/Textarea'
import style = ReactTextareaAutocomplete.propTypes.style
import YumCountrySelect from '../../../../components/YumCountrySelect/YumCountrySelect'
import YumTeamSelect from '../../../../components/YumTeamSelect/YumTeamSelect'
import { ButtonGroup } from '../../../../components/ButtonGroup/ButtonGroup'
import { Button } from '../../../../components/Button/Button'

import { ReactComponent as RemoveIcon } from '../../../../assets/v3/icons/remove.svg'
import { isTextFieldErrorVisible } from '../../../../common/helpers/formHelpers'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { TextFieldProps } from '@material-ui/core/TextField/TextField'

type Person = {
  firstName: string
  lastName: string
  createdAt: number
  status: boolean
}

export interface IUserAdminDispatchProps {
  getCompanyUsers(payload: GetSpecificCompanyUsers$Request): void
  getUserCompanyCountries(): void
  getCompanyDivisions(): void
  toggleUserStatus(payload: ToggleUserStatus$Request): void
  setUserCountry(payload: SetUserCountry$Request): void
  setUserDivision(payload: SetUserDivision$Request): void
  deleteUser(payload: DeleteUser$Request): void
  getCompanySignUpCode(payload: GetCompanySignUpCode$Request): void
  setCompanyUsersLoading(): void
}

export interface IUserAdminProps extends IUserAdminDispatchProps {
  companyUsers: UserDto[]
  usersLoading: boolean
  countries: CompanyCountriesDto[]
  divisions: DivisionDto[]
  managedCompanies: UserCompanyDto[]
  signUpCodes: { [companyId: CompanyId]: string }
}

//type IDashboardProps = IDashboardStateProps & IDashboardDispatchProps

/*const textFieldWithoutLabelStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: theme.palette.common.black,
  },
}))*/

function FilterTextField(props: TextFieldProps) {
  //const classes = textFieldWithoutLabelStyles()
  return (
    <TextField
      {...props}
      variant="outlined"
      InputProps={{
        autoComplete: 'new-password',
      }}
      inputProps={{
        style: {
          paddingTop: '15.5px',
          paddingBottom: '15.5px',
        },
      }}
      fullWidth={true}
      type="text"
      style={{
        marginTop: '5px',
        marginBottom: 0,
      }}
    />
  )
}

export default function UserAdmin(props: IUserAdminProps) {
  const {
    usersLoading,
    companyUsers,
    managedCompanies,
    signUpCodes,
    divisions,
    countries,
    setCompanyUsersLoading,
    setUserCountry,
    setUserDivision,
    deleteUser,
  } = props

  const [userCompany, setUserCompany] = useState(managedCompanies && (managedCompanies[0] as UserCompanyDto))
  //const [userLimit, setUserLimit] = useState(userCompany.userLimit)
  //const [companyId, setCompanyId] = useState(userCompany.companyId)

  const [companyCountries, setCompanyCountries] = useState({} as any)
  const [companyDivisions, setCompanyDivisions] = useState({} as any)
  const [userIdInDeletion, setUserIdInDeletion] = useState(null as UserId | null)
  const [fullNameInDeletion, setFullNameIdInDeletion] = useState('' as string)

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({})

  /*useEffect(() => {
    //do something when the row selection changes...
    console.info({ rowSelection })
  }, [rowSelection])*/

  const loadCompanyUsers = () => {
    const { getCompanyUsers, getCompanySignUpCode } = props
    const { companyId } = userCompany
    getCompanyUsers({ companyId })
    getCompanySignUpCode({ companyId })
  }

  // Legacy componentDidMount hook equivalent.
  React.useEffect(() => {
    const { getUserCompanyCountries, getCompanyDivisions } = props
    getUserCompanyCountries()
    getCompanyDivisions()
    loadCompanyUsers()
  }, [])

  React.useEffect(() => {
    setCompanyUsersLoading()
    loadCompanyUsers()
    setRowSelection({})

    setCompanyCountries(countries.find((country) => country.companyId === userCompany.companyId))
    setCompanyDivisions(divisions.filter((division) => division.companyId === userCompany.companyId))
  }, [userCompany])

  const handleCompanyChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    //setCompanyId(event.target.value as string)

    const { value } = event.target as { value: CompanyId }
    setUserCompany(managedCompanies.find((company) => company.companyId === value) as UserCompanyDto)
  }

  const toggleUserStatus = (companyId: CompanyId, userId: UserId) => () => {
    props.toggleUserStatus({ companyId, userId })
  }

  const handleCountryChange = (userId: UserId) => (event: React.ChangeEvent<{ value: unknown }>) => {
    const { companyId } = userCompany
    const { value } = event.target as { value: string }
    setUserCountry({ companyId, userId, country: value })
  }

  const handleDivisionChange = (userId: UserId) => (event: React.ChangeEvent<{ value: unknown }>) => {
    const { companyId } = userCompany
    const { value } = event.target as { value: DivisionId }
    setUserDivision({ companyId, userId, divisionId: value || null })
  }

  const openDeleteModal = (id: string, firstName: string, lastName: string, email: string) => () => {
    setUserIdInDeletion(id)
    setFullNameIdInDeletion(getFullName(firstName, lastName, email) + ' (' + email + ')')
  }
  const closeDeleteModal = () => setUserIdInDeletion(null)

  const handleDeleteUser = (userId: UserId) => () => {
    const { companyId } = userCompany
    deleteUser({ userId, companyId })
    setUserIdInDeletion(null)
  }

  const signUpCode = signUpCodes ? signUpCodes[userCompany.companyId] : false
  const contractPeriod = getContractPeriod(managedCompanies, userCompany.companyId)

  const columns = useMemo<MRT_ColumnDef<UserDto>[]>(
    () => [
      {
        accessorKey: 'firstName',
        header: t`First name`,
        Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
          <FilterTextField
            value={column.getFilterValue()}
            onChange={(event) => {
              const { value } = event.target as { value: string }
              column.setFilterValue(value || null)
            }}
          />
        ),
      },
      {
        accessorKey: 'lastName',
        header: t`Last name`,
        Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
          <FilterTextField
            value={column.getFilterValue()}
            onChange={(event) => {
              const { value } = event.target as { value: string }
              column.setFilterValue(value || null)
            }}
          />
        ),
      },
      {
        accessorKey: 'email',
        header: t`Email`,
        Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
          <FilterTextField
            value={column.getFilterValue()}
            onChange={(event) => {
              const { value } = event.target as { value: string }
              column.setFilterValue(value || null)
            }}
          />
        ),
      },
      {
        accessorKey: 'divisionId',
        header: t`Team`,
        Cell: ({
          row: {
            original: { divisionId, userId },
          },
        }: any) =>
          companyDivisions.length ? (
            <YumTeamSelect
              /*label={t`Team`}*/
              companyDivisions={companyDivisions}
              value={divisionId || ''}
              onChange={handleDivisionChange(userId)}
              /*useAutocompleteSelect={useAutocompleteSelect}*/
              style={{
                marginBottom: 0,
              }}
            />
          ) : (
            ''
          ),
        Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
          <YumTeamSelect
            companyDivisions={companyDivisions}
            value={column.getFilterValue()}
            onChange={(event) => {
              const { value } = event.target as { value: DivisionId }
              column.setFilterValue(value || null)
            }}
            /*useAutocompleteSelect={useAutocompleteSelect}*/
            style={{
              marginTop: '5px',
              marginBottom: 0,
            }}
          />
        ),
      },
      {
        accessorKey: 'country',
        header: t`Country`,
        Cell: ({
          row: {
            original: { country, userId },
          },
        }: any) =>
          companyCountries && companyCountries.countries && companyCountries.countries.length ? (
            <YumCountrySelect
              /*label={t`Country`}*/
              countries={companyCountries.countries}
              value={country || ''}
              onChange={handleCountryChange(userId)}
              /*useAutocompleteSelect={useAutocompleteSelect}*/
              style={{
                marginBottom: 0,
              }}
            />
          ) : (
            ''
          ),
        Filter: ({ column }: { column: MRT_Column<UserDto> }) => (
          <YumCountrySelect
            countries={companyCountries.countries}
            value={column.getFilterValue()}
            onChange={(event) => {
              const { value } = event.target as { value: string }
              column.setFilterValue(value || null)
            }}
            /*useAutocompleteSelect={useAutocompleteSelect}*/
            style={{
              marginTop: '5px',
              marginBottom: 0,
            }}
          />
        ),
      },
      {
        accessorKey: 'createdAt',
        header: t`Registration date`,

        accessorFn: (row) => new Date(row.createdAt), //convert to Date for sorting and filtering
        //id: 'startDate',
        //header: 'Start Date',

        // TODO: Fix filter and enable it
        enableColumnFilter: false,

        filterFn: 'lessThanOrEqualTo',
        sortingFn: 'datetime',
        Cell: ({ cell }) => getShortDateWithTimeString(cell.getValue<Date>()?.getTime()), //render Date as a string
        //Header: ({ column }) => <em>{column.columnDef.header}</em>, //custom header markup
        //Custom Date Picker Filter from @mui/x-date-pickers
        /*Filter: ({ column }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(newValue) => {
                column.setFilterValue(newValue)
              }}
              slotProps={{
                textField: {
                  helperText: 'Filter Mode: Less Than',
                  sx: { minWidth: '120px' },
                  variant: 'standard',
                },
              }}
              value={column.getFilterValue()}
            />
          </LocalizationProvider>
        ),*/
      },
      {
        accessorKey: 'onboardingStatus',
        header: t`Onboarding status`,
        filterVariant: 'select',
        filterSelectOptions: ['PROFILE_DATA', 'INTEGRATION', 'DONE'],
      },
      {
        //header: 'Account Status',
        //accessorFn: (originalRow) => (originalRow.isActive ? 'true' : 'false'), //must be strings
        //id: 'isActive',
        filterVariant: 'checkbox',
        //Cell: ({ cell }) =>
        //  cell.getValue() === 'true' ? 'Active' : 'Inactive',
        size: 220,

        accessorKey: 'active',
        header: t`Status`,
        //Cell: ({ original: { active, userId } }: RowInfo) => (
        Cell: ({
          row: {
            original: { userId, active },
          },
        }: any) => (
          <YumSwitch checked={active} onChange={toggleUserStatus(userCompany.companyId, userId)} color="primary" />
        ),
      },

      // Delete/remove row, remove once multi-remove is implemented.
      {
        enableSorting: false,
        enableColumnFilter: false,
        header: t`Delete`,
        Cell: ({
          row: {
            original: { userId, firstName, lastName, email },
          },
        }: any) => (
          <>
            <IconButton
              style={{ color: red }}
              aria-label="delete"
              onClick={openDeleteModal(userId, firstName, lastName, email)}
            >
              <RemoveIcon
                style={{
                  width: 24,
                  height: 24,
                }}
              />
            </IconButton>
          </>
        ),
        // @ts-ignore
        /*style: { width: '20px !important', alignSelf: 'right' },
        sortable: false,
        width: 80,*/
      },
    ],
    [companyCountries],
  )

  /*const columns: any = [
    {
      className: Table.rankBEM(companyUsersLength),
      headerClassName: Table.rankBEM(companyUsersLength),
      sortable: false,
      id: 'index',
      Cell: ({ viewIndex }: CellInfo) => <span>{`${viewIndex + 1}.`}</span>,
      style: { alignSelf: 'center' },
    },
    {
      Header: t`Name`,
      id: 'fullName',
      Cell: ({ original: { firstName, lastName, email } }: CellInfo) => (
        <>
          {/!*<Initials isCompleted={isCompleted} fullName={getFullName(firstName, lastName, email)} />*!/}
          <span>
            {firstName || lastName ? getFullName(firstName, lastName, email) : ''}
            <div className="text-gray">{email}</div>
          </span>
        </>
      ),
      accessor: (original: { firstName: string; lastName: string; email: string }) =>
        getFullName(original.firstName, original.lastName, original.email),
      style: { alignSelf: 'center' },
      //width: 200,
      minWidth: 200,
    },
    {
      Header: t`Registration date`,
      accessor: 'createdAt',
      Cell: ({ original }: RowInfo) => getShortDateWithTimeString(original.createdAt),
      style: { alignSelf: 'center', whiteSpace: 'nowrap' },
      minWidth: 200,
    },
  ]*/

  return (
    <Card>
      <NotificationsWrapper />

      <Grid container justifyContent="space-between" alignContent="center" alignItems="center">
        <Grid item xs={12} sm={8} style={{ paddingBottom: '10px' }}>
          <h1 style={{ marginBottom: 3 }}>
            {t`User management`}
            {!usersLoading && (
              <span style={{ opacity: 0.5, whiteSpace: 'nowrap' }}>
                {' '}
                ({companyUsers.length}
                {userCompany.userLimit && `/${userCompany.userLimit}`})
              </span>
            )}
          </h1>
          {/*<Button className="register__submit" url={ROUTES.ADMIN_USER_NEW.to} text={t`Add user`} />*/}
        </Grid>
        {managedCompanies.length > 1 ? (
          <Grid item style={{ overflow: 'hidden', paddingBottom: '1rem' /*, paddingLeft: '10px'*/ }}>
            <YumSmallSelect variant="outlined" value={userCompany.companyId} onChange={handleCompanyChange}>
              {managedCompanies.map((userCompany: UserCompanyDto, keyIndex: number) => (
                <option key={keyIndex} value={userCompany.companyId}>
                  {userCompany.companyName}
                </option>
              ))}
            </YumSmallSelect>
          </Grid>
        ) : (
          ''
        )}
      </Grid>

      {!usersLoading && signUpCode ? (
        <Hidden mdUp>
          <div style={{ marginBottom: '10px' }}>
            {t`Sign up code`}: <strong>{signUpCode}</strong>
            <br />
            {contractPeriod && (
              <>
                <Hidden smDown>{` | `}</Hidden>
                {contractPeriod}
              </>
            )}
          </div>
        </Hidden>
      ) : (
        ''
      )}

      <div style={{ marginTop: '10px' }}>
        <MaterialReactTable
          muiTablePaperProps={{ elevation: 0 }}
          enableRowNumbers
          rowNumberMode="static"
          /*enableRowSelection*/
          getRowId={(row) => row.userId}
          onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
          state={{
            rowSelection,
            /*columnVisibility: {
              divisionId: companyDivisions.length,
              country: companyCountries && companyCountries.countries && companyCountries.countries.length,
            },*/
          }} //pass our managed row selection state to the table to use
          columns={columns}
          data={props.companyUsers}
          enableDensityToggle={false}
          enableFullScreenToggle={false}
          initialState={{
            isLoading: usersLoading,
            sorting: [
              {
                id: 'createdAt',
                desc: true,
              },
            ],
            density: 'compact',
            columnVisibility: {
              onboardingStatus: false,
            },
          }}
          muiSearchTextFieldProps={{
            placeholder: t`Search`,
            style: { marginTop: '5px' },
            /*sx: { minWidth: '300px' },*/
            /*variant: 'filled',
            margin: 'dense',*/
            /*InputProps: {
              disableUnderline: true,
            },*/
          }}
          positionToolbarAlertBanner="bottom" //show selected rows count on bottom toolbar
          //add custom action buttons to top-left of top toolbar
          /*muiTopToolbarProps={{ component: 'div' }}*/
          renderTopToolbarCustomActions={({ table }) =>
            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected() ? (
              <>
                {!usersLoading && signUpCode ? (
                  <Hidden smDown>
                    <div style={{ margin: '10px 5px' }}>
                      {t`Sign up code`}: <strong>{signUpCode}</strong>
                      {contractPeriod && (
                        <>
                          {` | `}
                          {contractPeriod}
                        </>
                      )}
                    </div>
                  </Hidden>
                ) : (
                  ''
                )}
                &nbsp;
              </>
            ) : (
              <Box sx={{ display: 'flex', gridGap: '0.5rem', /*gap: '1rem',*/ p: '4px' }}>
                <YumButton
                  color="secondary"
                  onClick={(x) => {
                    const userIdsForSettingActive = table
                      .getSelectedRowModel()
                      .flatRows.map(({ original: { userId } }: any) => userId)
                    console.log('userIdsForSettingActive', userIdsForSettingActive)
                  }}
                  variant="contained"
                  size={'small'}
                >
                  {t`Set active`}
                </YumButton>
                <YumButton
                  onClick={(x) => {
                    const userIdsForSettingInactive = table
                      .getSelectedRowModel()
                      .flatRows.map(({ original: { userId } }: any) => userId)
                    console.log('userIdsForSettingInactive', userIdsForSettingInactive)
                  }}
                  variant="contained"
                  size={'small'}
                >
                  {t`Set inactive`}
                </YumButton>
                <YumButton
                  /*color="error"*/
                  onClick={(x) => {
                    const userIdsForRemoval = table
                      .getSelectedRowModel()
                      .flatRows.map(({ original: { userId } }: any) => userId)
                    console.log('userIdsForRemoval', userIdsForRemoval)
                  }}
                  variant="contained"
                  size="small"
                  color="default"
                >
                  {t`Remove`}
                </YumButton>
                {/*<YumButton
                  onClick={(x) => {
                    const userIdsForDeletion = table
                      .getSelectedRowModel()
                      .flatRows.map(({ original: { userId } }: any) => userId)
                    console.log('userIdsForDeletion', userIdsForDeletion)
                  }}
                  variant="contained"
                  size="small"
                  color="default"
                >
                  {t`Delete`}
                </YumButton>*/}
              </Box>
            )
          }
          //customize built-in buttons in the top-right of top toolbar
          renderToolbarInternalActions={({ table }) => (
            <Box display="flex" gridGap="xs">
              <MRT_ToggleGlobalFilterButton table={table} />
              <MRT_ToggleFiltersButton table={table} />
              <Hidden smDown>
                <MRT_FullScreenToggleButton
                  table={table}
                  onClick={() => {
                    const { getState, setIsFullScreen } = table
                    const { isFullScreen } = getState()

                    setIsFullScreen(!isFullScreen)

                    if (!isFullScreen) {
                      document.querySelectorAll<HTMLElement>('.nav')[0].style.zIndex = '0'
                      document.querySelectorAll<HTMLElement>('.layout__header')[0].style.zIndex = '0'
                    } else {
                      document.querySelectorAll<HTMLElement>('.nav')[0].style.zIndex = '10'
                      document.querySelectorAll<HTMLElement>('.layout__header')[0].style.zIndex = '100'
                    }
                  }}
                />
              </Hidden>
              {/*<IconButton
                aria-label="export"
                onClick={() => {
                  alert('export')
                }}
              >
                <FileDownloadIcon />
              </IconButton>*/}
            </Box>
          )}
          /*renderTopToolbar={({ table }) => (
            <>
              <Box display="flex" gridGap="xs">
                <MRT_GlobalFilterTextField table={table} />
                <IconButton
                  aria-label="export"
                  onClick={() => {
                    alert('export')
                  }}
                >
                  <FileDownloadIcon />
                </IconButton>
              </Box>
            </>
          )}*/
          /*renderTopToolbar={({ table }) => (
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box>
                <MRT_ShowHideColumnsButton table={table} />
                <MRT_FullScreenToggleButton table={table} />
              </Box>
            </Box>
          )}*/
          muiTableBodyProps={{
            sx: (theme) => ({
              '& tr:hover td': {
                backgroundColor: gray,
                '& .MuiFilledInput-root': {
                  backgroundColor: 'white !important',
                },
              },
            }),
          }}
          localization={{
            rowsPerPage: t`Rows per page`,
            noResultsFound: t`No matches found.`,
            noRecordsToDisplay: t`No matches found.`,
            search: t`Search`,

            clearSort: t`Clear sort`,
            clearFilter: t`Clear filter`,
            hideColumn: t`Hide {column} column`,
            showAllColumns: t`Show all columns`,
            sortByColumnAsc: t`Sort by {column} ascending`,
            sortByColumnDesc: t`Sort by {column} descending`,
            filterByColumn: t`Filter by {column}`,
            selectedCountOfRowCountRowsSelected: t`{selectedCount} of {rowCount} row(s) selected`,
            of: t`of`,

            showHideSearch: '',
            showHideFilters: '',
            clearSearch: '',
            sortedByColumnAsc: '',
            sortedByColumnDesc: '',
            columnActions: '',
            goToFirstPage: '',
            goToLastPage: '',
            goToNextPage: '',
            goToPreviousPage: '',
            toggleSelectAll: '',
            toggleSelectRow: '',
            toggleFullScreen: '',
          }}
        />
      </div>

      <Dialog disableEnforceFocus open={!!userIdInDeletion}>
        <DialogTitle>{t`Delete user?`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t`Are you sure you want to delete`} <br />
            <strong>{fullNameInDeletion}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGroup>
            <Button text={t`Delete`} onClick={handleDeleteUser(userIdInDeletion as string)} className="bg-red" />
            <Button text={t`Cancel`} link={true} onClick={closeDeleteModal} />
          </ButtonGroup>
        </DialogActions>
      </Dialog>
    </Card>
  )
}
